import { render, staticRenderFns } from "./ElementUIGroupSelect.vue?vue&type=template&id=c8470ab2&scoped=true"
import script from "./ElementUIGroupSelect.vue?vue&type=script&lang=js"
export * from "./ElementUIGroupSelect.vue?vue&type=script&lang=js"
import style0 from "./ElementUIGroupSelect.vue?vue&type=style&index=0&id=c8470ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8470ab2",
  null
  
)

export default component.exports